import { observer } from 'mobx-react';
import React from 'react';
import { LocalizedHtml, useI18n } from '@udemy/i18n';
import { Badge } from '@udemy/react-messaging-components';
import { useHeaderStore } from '../../../hooks/use-header-store';
import styles from "../../../mobile/mobile-nav/mobile-nav.module.css";
import { MobileNavItem, MobileNavL1Nav, MobileNavSection } from '../../../mobile/mobile-nav/mobile-nav.react-component';
export const levelTwoNavIdMap = {
  'header.manage-ufb.users': 'header-toggle-side-nav-manage-users',
  'header.manage-ufb.courses': 'header-toggle-side-nav-manage-courses',
  'header.manage-ufb.assigned': 'header-toggle-side-nav-manage-assigned',
  'header.manage-ufb.insights': 'header-toggle-side-nav-manage-insights',
  'header.manage-ufb.settings': 'header-toggle-side-nav-manage-settings',
  'header.manage-ufb.subscription-and-billing': 'header-toggle-side-nav-manage-subscription-and-billing'
};
export const MobileL1ManageNav = observer(() => {
  const headerStore = useHeaderStore();
  const {
    gettext
  } = useI18n();
  function renderMenuItem(item) {
    const cssToggleId = levelTwoNavIdMap[item.id];
    if (item.children) {
      return /*#__PURE__*/React.createElement(MobileNavItem, {
        key: item.id,
        cssToggleId: cssToggleId
      }, item.title);
    }
    return /*#__PURE__*/React.createElement(MobileNavItem, {
      key: item.id,
      href: item.url
    }, item.is_beta ? /*#__PURE__*/React.createElement(LocalizedHtml, {
      html: interpolate(gettext('%(title)s <span class="beta">Beta</span>'), {
        title: item.title
      }, true),
      interpolate: {
        beta: /*#__PURE__*/React.createElement(Badge, {
          className: styles.beta
        })
      }
    }) : item.title);
  }
  const {
    organizationManageMenu
  } = headerStore.userSpecificContext;
  return /*#__PURE__*/React.createElement(MobileNavL1Nav, {
    id: "header-toggle-side-nav-manage",
    "data-testid": "mobile-l1-manage-nav"
  }, /*#__PURE__*/React.createElement(MobileNavSection, null, organizationManageMenu.map(renderMenuItem)));
});
//# sourceMappingURL=mobile-l1-manage-nav.react-component.js.map